<template>
  <div class="text-sm-left">
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>

    <b-row class="mt-4">
        <b-col sm="12" md="6" lg="4" xl="4" v-if="cargandoMedio">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
         </b-col>

        <b-col v-else sm="12" md="4" lg="4" xl="4" v-for="lista in listaEnterarse" :key="lista.label">
            <div class="d-flex justify-content-center align-items-center title mb-3">
                <p class="m-0 p-0">{{ lista.label }}</p>
            </div>
            <div class="d-flex justify-content-between pl-3 pr-1" v-for="(lst, key) in lista.options" v-bind:key="key">
                <p class="text">{{ lst.medio }}</p>
                <b-form-radio
                    v-model="persona.idMedio"
                    name="some-radios"
                    :value="lst.idMedio"
                />
            </div>
        </b-col>
    </b-row>
    <b-form-invalid-feedback class="mb-4" :state="persona.idMedio != null">
      Se debe seleccionar una opción
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: "DatosPacienteHC",
  props: {
    persona: Object,
    listaEnterarse: Array,
    listaSexo: Array,
    cargandoPlanes: Boolean,
    cargandoCercania: Boolean,
    cargandoConfianza: Boolean,
    cargandoMedio: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    nombrePlan: "",
    idPlan: null,
    optionsPlan: [
      { text: "Titular", value: 1 },
      { text: "Beneficiario", value: 2 },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
    label {
        color: #0046a2 !important;
    }

    .title{
        background-color: antiquewhite;
        color: #0046a2;
        font-weight: 600;
        font-size: .8em;
        height: 2em;
        border-radius: 5px;
    }

    .text{
        color: #0046a2;
        font-weight: 600;
        font-size: .8em;
    }

</style>
